import { Layout } from "antd";
import React, { useMemo } from "react";
import { CheckoutInfoResponse } from "../../../types/CheckoutInfoResponse";
import InfoCard from "../shared/InfoCard";

type CreditCardTypeProps = {
  getCheckoutInfoData: CheckoutInfoResponse;
};

const { Content } = Layout;

const IdBankCardMode = ({ getCheckoutInfoData }: CreditCardTypeProps) => {
  const amountInfoList = useMemo(() => {
    return [
      {
        label: "Jumlah yang Harus Dibayar",
        value: getCheckoutInfoData?.orderAmount
      }
    ];
  }, [getCheckoutInfoData]);

  const bankInfoList = useMemo(() => {
    return [
      {
        label: "Nomor Virtual Account",
        value: getCheckoutInfoData?.receiverAccount
      },
      {
        label: "Nama Bank",
        value: getCheckoutInfoData?.receiverBank
      }
    ];
  }, [getCheckoutInfoData]);
  return (
    <Content>
      <InfoCard
        cardTitle="Informasi"
        descTitle="jumlah"
        itemList={amountInfoList}
      />
      <InfoCard
        cardTitle="Langkah 1. Salin detail Bank dan transfer uang ke rekening"
        descTitle="Akun bank"
        itemList={bankInfoList}
      />
    </Content>
  );
};

export default IdBankCardMode;
